export const TABS = ['notifications', 'upcoming', 'ongoing', 'pastShifts'] as const;
export type ShiftTab = (typeof TABS)[number];

// Default tab constant to avoid hardcoded values
export const DEFAULT_TAB: ShiftTab = 'notifications';
